
            const data = {"name":"icon-checkmark","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M.64 16.93a.5.5 0 01.72-.71l9.52 9.53a.5.5 0 01-.71.71L.64 16.93z\"/><path pid=\"1\" _fill=\"currentColor\" d=\"M10.88 26.46a.5.5 0 01-.71-.71L31 4.9a.5.5 0 01.71.71L10.89 26.46z\"/>"}}
        
                module.exports = data
                